/**
 * API base URLs — override via .env when needed:
 *   REACT_APP_MAIN_URL=https://api.erp.nsplprojects.com
 */

const LIVE_URL = "https://api.erp.nsplprojects.com";
const LOCAL_URL = "http://127.0.0.1:8000";

/** Primary API (auth, organizations, attendance) */
export const MAIN_URL = process.env.REACT_APP_MAIN_URL || LIVE_URL;

/** Same backend as MAIN_URL; kept for parity with HR / EMS / PM frontends */
export const OTHER_LIVE_URL =
  process.env.REACT_APP_OTHER_LIVE_URL || MAIN_URL;

/** Scopes login, permissions, and org access to HR (attendance is part of HR ERP) */
export const APPLICATION_KEY = "hr";

export function getApiHeaders(extraHeaders = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...extraHeaders,
  };
  const token = localStorage.getItem("token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (APPLICATION_KEY) {
    headers["X-Application-Key"] = APPLICATION_KEY;
  }
  return headers;
}
